import { render, staticRenderFns } from "./UserGroupAddUpdate.vue?vue&type=template&id=72da258e&scoped=true"
import script from "./UserGroupAddUpdate.vue?vue&type=script&lang=js"
export * from "./UserGroupAddUpdate.vue?vue&type=script&lang=js"
import style0 from "./UserGroupAddUpdate.vue?vue&type=style&index=0&id=72da258e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da258e",
  null
  
)

export default component.exports